module.exports = __webpack_public_path__ + "static/media/ressi.92a4b8b4.webp";